<template>
  <div>
    <span :style="tooltipIconPos" class="tooltip-icon" :class="{'tooltip-icon--default':!hasIconSlot}"
          v-on="!openOnClick ? { mouseenter: () => {tooltipShow = true}, mouseleave: () => {tooltipShow = false} } : {click: () => {tooltipShow = !tooltipShow}}">
      <slot name="icon">i</slot>
    </span>
    <v-popover
        v-if="tooltipShow"
        :style="tooltipPos"
        placement="bottom-end"
        style="position: absolute;"
        trigger="manual"
        :popoverClass="tooltipClass"
        :open.sync="tooltipShow"
    >
      <template slot="popover">
        <template v-if="cannedTooltip">
          <p v-html="cannedTooltipText[cannedTooltip]"></p>
        </template>
        <slot v-else></slot>
      </template>
    </v-popover>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  data () {
    return {
      tooltipShow: false,
      cannedTooltipText: {
        nps: `This score indicates how likely it is for reviewers to recommend this business. Less than 0 = unlikely, 1 to 49 = likely and above 49 = very likely. For more information on how the NPS is collected and calculated, <a href="https://intercom.help/hellopeter/en/articles/3677918-your-net-promoter-score" target="_blank" class="link--v2 link--no-line">read more here</a>.`
      }
    }
  },
  props: {
    iconTop: {
      type: Number,
      default: null
    },
    iconRight: {
      type: Number,
      default: null
    },
    iconBottom: {
      type: Number,
      default: null
    },
    iconLeft: {
      type: Number,
      default: null
    },
    tooltipTop: {
      type: Number,
      default: null
    },
    tooltipRight: {
      type: Number,
      default: null
    },
    tooltipBottom: {
      type: Number,
      default: null
    },
    tooltipLeft: {
      type: Number,
      default: null
    },
    tooltipClass: {
      type: String,
      default: ''
    },
    cannedTooltip: {
      type: String,
      default: ''
    },
    openOnClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasIconSlot () {
      return 'icon' in this.$slots
    },
    tooltipIconPos () {
      return preparePosObject({
        top: this.iconTop,
        right: this.iconRight,
        bottom: this.iconBottom,
        left: this.iconLeft
      })
    },
    tooltipPos () {
      return preparePosObject({
        top: this.tooltipTop,
        right: this.tooltipRight,
        bottom: this.tooltipBottom,
        left: this.tooltipLeft
      })
    }
  }
}

const preparePosObject = (values) => {
  const pos = {}

  for (const direction in values) {
    if (values[direction] !== null) {
      pos[direction] = values[direction] + 'px'
    }
  }

  return pos
}
</script>



// WEBPACK FOOTER //
// src/components/Tooltip.vue